// PermissionContext.tsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { getUserModulePermissionApi } from "../../api/user-api";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";

const PermissionContext = createContext<{ allowedRoutes: string[], loading: boolean }>({ allowedRoutes: [], loading: true });



const hasAnyPermission = (item: any): boolean =>
  item.create === 1 || item.view === 1 || item.update === 1 || item.delete === 1 || item.download === 1;

export const PermissionProvider = ({ children }: { children: React.ReactNode }) => {
  const [allowedRoutes, setAllowedRoutes] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const { isLoggedIn } = useSelector((state: RootState) => state.auth)

  
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const res = await getUserModulePermissionApi();
        if (res.status === 200) {
          // const routePaths = res.data.data.map((item: any) => item.path.toLowerCase());
          const routePaths = res.data?.data?.filter((item: any) => hasAnyPermission(item))?.map((item: any) => item?.path?.toLowerCase());
          // const routePaths = myStaticData?.filter((item: any) => hasAnyPermission(item))?.map((item: any) => item?.path?.toLowerCase());
          setAllowedRoutes(routePaths);
        }
      } catch (error) {
        console.error("Error fetching user modules", error);
      } finally {
        setLoading(false);
      }
    };
    if(isLoggedIn){
      fetchPermissions();
    }
  }, [isLoggedIn]);

  return (
    <PermissionContext.Provider value={{ allowedRoutes, loading }}>
      {children}
    </PermissionContext.Provider>
  );
};

export const routePermission = () => useContext(PermissionContext);
